var render = function render(_c,_vm){return _c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._l((_vm.props.track.artists),function(artist,index){return [(index > 0)?_c('span',{key:artist.id},[_vm._v(", ")]):_vm._e(),(artist.id)?_c('router-link',{key:`${artist.id}-link`,attrs:{"to":{name: 'artist', params: { id: artist.id }}}},[_vm._v(" "+_vm._s(artist.name)+" ")]):[_vm._v(" "+_vm._s(artist.name)+" ")]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }